import { render, staticRenderFns } from "./TutuOrder.vue?vue&type=template&id=a37092bc"
import script from "./TutuOrder.vue?vue&type=script&lang=js"
export * from "./TutuOrder.vue?vue&type=script&lang=js"
import style0 from "./TutuOrder.vue?vue&type=style&index=0&id=a37092bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports